var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { trackProductEvent } from '@jetshop/core/analytics/tracking';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useTracker } from '../../analytics/Analytics';
import { useShopConfig } from '../../hooks/useShopConfig';
import ProductConfigurationProvider from '../ProductConfigurationProvider/ProductConfigurationProvider';
import { StructuredProductData } from '../StructuredData';
import { OpenGraphProductData } from '../OpenGraph';
import { unSlugify } from '@jetshop/core/analytics/integrations/unslugify';
import { breadcrumbsWithoutProduct } from '@jetshop/core/analytics/utils/breadcrumbsWithoutProduct';
const ProductRoute = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { component: ProductPage, partialProduct } = props, rest = __rest(props, ["component", "partialProduct"]);
    const product = ((_b = (_a = props.result.data) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.object) || ((_c = props.result.data) === null || _c === void 0 ? void 0 : _c.product);
    const { structuredData, openGraph } = useShopConfig();
    const location = useLocation();
    const track = useTracker();
    const disableStructuredProductData = structuredData
        ? !!structuredData.disableDefaultProductData
        : false;
    const disableOpenGraphProductData = openGraph
        ? !!openGraph.disableDefaultProductData
        : false;
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (((_b = (_a = props.result.data) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.object) || ((_c = props.result.data) === null || _c === void 0 ? void 0 : _c.product)) {
            const category = breadcrumbsWithoutProduct(((_e = (_d = props.result.data) === null || _d === void 0 ? void 0 : _d.route) === null || _e === void 0 ? void 0 : _e.breadcrumbs) ||
                ((_h = (_g = (_f = props.result.data) === null || _f === void 0 ? void 0 : _f.product) === null || _g === void 0 ? void 0 : _g.primaryRoute) === null || _h === void 0 ? void 0 : _h.breadcrumbs)) ||
                unSlugify((_k = (_j = product.canonicalCategory) === null || _j === void 0 ? void 0 : _j.primaryRoute) === null || _k === void 0 ? void 0 : _k.path) ||
                '';
            track(trackProductEvent({
                action: 'view',
                product,
                list: (_l = location.state) === null || _l === void 0 ? void 0 : _l.list,
                category
            }));
        }
    }, [
        (_d = location.state) === null || _d === void 0 ? void 0 : _d.list,
        product,
        (_e = props.result.data) === null || _e === void 0 ? void 0 : _e.product,
        (_g = (_f = props.result.data) === null || _f === void 0 ? void 0 : _f.route) === null || _g === void 0 ? void 0 : _g.breadcrumbs,
        (_j = (_h = props.result.data) === null || _h === void 0 ? void 0 : _h.route) === null || _j === void 0 ? void 0 : _j.object,
        track
    ]);
    return (React.createElement(React.Fragment, null,
        product && (React.createElement(React.Fragment, null,
            !disableStructuredProductData && (React.createElement(StructuredProductData, { product: product })),
            !disableOpenGraphProductData && (React.createElement(OpenGraphProductData, { product: product })))),
        React.createElement(ProductConfigurationProvider, { product: product },
            React.createElement(ProductPage, Object.assign({}, rest, { product: product, partialProduct: partialProduct })))));
};
export default ProductRoute;
//# sourceMappingURL=ProductRoute.js.map